module.exports = __webpack_public_path__ + "img/hc-icon05.04dda770.svg";